/**
 * Ets2AffidavitStatus generated based on backend enum.
 */
export type Ets2AffidavitStatus =
  | 'Undefined'
  | 'Received'
  | 'DocumentsGenerated'
  | 'SentForSign'
  | 'OperatorReview'
  | 'ProcessedApproved'
  | 'ProcessedRejected'
  | 'ProcessedMixed'
  | 'SignForwardError'
  | 'ExceptionCreateError'
  | 'Cancelled'
  | 'WaitingForSignedDocuments';

export const Ets2AffidavitStatus = {
  Undefined: 'Undefined' as Ets2AffidavitStatus,
  Received: 'Received' as Ets2AffidavitStatus,
  DocumentsGenerated: 'DocumentsGenerated' as Ets2AffidavitStatus,
  SentForSign: 'SentForSign' as Ets2AffidavitStatus,
  OperatorReview: 'OperatorReview' as Ets2AffidavitStatus,
  ProcessedApproved: 'ProcessedApproved' as Ets2AffidavitStatus,
  ProcessedRejected: 'ProcessedRejected' as Ets2AffidavitStatus,
  ProcessedMixed: 'ProcessedMixed' as Ets2AffidavitStatus,
  SignForwardError: 'SignForwardError' as Ets2AffidavitStatus,
  ExceptionCreateError: 'ExceptionCreateError' as Ets2AffidavitStatus,
  Cancelled: 'Cancelled' as Ets2AffidavitStatus,
  WaitingForSignedDocuments: 'WaitingForSignedDocuments' as Ets2AffidavitStatus
};